<div class="upper-part d-flex">
    <div class="line-icon">
        <img src="../../../assets/images/bottom_sheet_rectangle.svg" alt="Line Icon" />
    </div>
    <!-- <div class="close-button">
      <img src="../../../../../assets/images/crossIconDarkTheme.svg" alt="Close" />
    </div> -->
</div>

<div class="status-container">
    @if (data.showSlot) {
    <span class="title">Panja Receiving Slot - {{data.slot}}</span>
    }
    <div class="checkbox-details">
        @for(item of data.data; track item){
        <div class="custom-checkbox">

            <input type="checkbox" name="checkbox" id="checkbox" [formControl]="renewDue">
            <span [ngClass]="item.isfailed ? 'fail-checkmark' : 'checkmark'" [class.blink]="data.length-1"></span>
            <div class="d-flex flex-column">
                <span class="count">{{item.statusDesc}}</span>
                @if(item.isfailed){
                @if(item.renewalProcess.length > 1){
                <small style="color: var(--text-tertiary);">{{item.latestRemark.remarks}}</small>
                }@else{
                @for(remark of item.renewalProcess; track remark){
                <small style="color: var(--text-tertiary);">{{remark.remarks}}</small>

                }
                }
                }
            </div>
        </div>
        }

    </div>
</div>